import React, { Suspense, lazy } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
const BelowFold = lazy(() => import('./components/BelowFold').then(module => ({
  default: module.BelowFold
})));
export function App() {
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="3fahyiundazbl">
      <UrgencyBar data-id="element-1" data-mp="3fb14re3nnz9s" />
      <Hero data-id="element-2" data-mp="3f8eydhsi3pt5" />
      <Suspense fallback={null} data-id="element-3" data-mp="2rkx33ca129lf">
        <BelowFold data-id="element-4" data-mp="2rk46v58p32hj" />
      </Suspense>
    </div>;
}